// @flow
import MustEnableEMoney from './MustEnableEMoney';

export default MustEnableEMoney;
